import React, { useState } from 'react';
import { Button, Image, Text } from '@asigna/kit';
import cx from 'classnames';
import useData, { PROVIDERS } from 'hooks/useData';
import closeIcon from 'images/close.svg';
import Leather from 'images/logo/leather.png';
import LedgerIcon from 'images/logo/ledger.svg';
import Logo4 from 'images/logo/logo4.svg';
import { useAtom } from 'jotai';
import { ledgerDialogAtom } from 'store/ledger/ledger-dialog';
import { isWalletInstalled } from 'utils/provider';

interface TransactionCommonProps {
  open: boolean;
  onClose: () => void;
}

export type ConnectWalletItem = {
  install: boolean;
  link: string;
  logo: any;
  title: string;
};

export const getWalletConenctors = () => {
  return [
    {
      title: 'Leather',
      logo: Leather,
      install: isWalletInstalled('Leather'),
      link: 'https://chromewebstore.google.com/detail/leather/ldinpeekobnhjjdofggfgjlcehhmanlj',
    },
    {
      title: 'Xverse',
      logo: Logo4,
      install: isWalletInstalled('Xverse'),
      link: 'https://chromewebstore.google.com/detail/xverse-wallet/idnnbdplmphpflfnlkomgpfbpcgelopg',
    },
    {
      title: 'Ledger',
      logo: LedgerIcon,
      install: true,
      link: '#',
    },
  ];
};

export const ConnectWalletModal: React.FC<TransactionCommonProps> = ({ open, onClose }) => {
  const WalletConnectors = getWalletConenctors();
  const [error, setError] = useState<string | null>(null);

  const [, setLedgerDialog] = useAtom(ledgerDialogAtom);
  const { makeAuthRequest } = useData();

  const handleWalletClick = async (item: ConnectWalletItem) => {
    if (item.install && item.link !== '') {
      if (item.title === 'Ledger') {
        setLedgerDialog({ isConnectOpened: true });

        return;
      }

      setError(null);

      try {
        const provider = item.title === 'Leather' ? PROVIDERS.Leather : PROVIDERS.Xverse;
        await makeAuthRequest(provider);
      } catch (e) {
        const message =
          e instanceof Error ? e.message : typeof e === 'string' ? e : JSON.stringify(e);
        setError(message);
      }
    }
  };

  return (
    <div className="flex flex-col gap-16">
      <div className="flex items-center justify-between">
        <Text message="Connect wallet" size="r20" />
        {/* TODO Icon Button */}
        <Button
          leftIcon={closeIcon}
          onClick={onClose}
          colorType="inherit"
          size="sm"
          className="w-40 h-40 border-[.5px] border-black-4 !px-0 hover:bg-white-3"
        />
      </div>
      {error && <p className="text-red-500 text-sm break-all">{error}</p>}
      <div className="flex flex-col gap-12 w-full">
        {WalletConnectors.map((item) => (
          <button
            key={item.title}
            className={cx(
              'rounded-[12px] border-[.5px] border-black-4 bg-white-3 hover:bg-black-3 flex py-8 px-12 items-center justify-between gap-12 flex-1 h-[56px]',
              !item.install && 'opacity-70'
            )}
            onClick={() => handleWalletClick(item)}
          >
            <div className="flex gap-8 items-center h-40">
              <Image src={item.logo} size={28} />
              <Text message={item.title} color="white" size="m14" />
            </div>
            {!item.install && <span onClick={() => window.open(item.link)}>Install</span>}
          </button>
        ))}
      </div>
    </div>
  );
};
